const Header = () => {
  return (
    <div className="header">
      <h1 className="display-1">Github Display</h1>
      <h2 className="display-6">
        Display Info for Any Github User
      </h2>
      <p>An API demonstration by <a href='http://grantvanb.ca'>Grant van Boeschoten</a> </p>
    </div>
  );
};

export default Header;
